"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletState = exports.validateDepositReceipt = void 0;
// eslint-disable-next-line valid-jsdoc
/**
 * Validates the given deposit receipt. Throws in case of a validation error.
 * @param receipt The validated deposit receipt.
 * @dev This function does not validate the depositor's identifier as its
 *      validity is chain-specific. This parameter must be validated outside.
 */
function validateDepositReceipt(receipt) {
    if (receipt.blindingFactor.toString().length != 16) {
        throw new Error("Blinding factor must be an 8-byte number");
    }
    if (receipt.walletPublicKeyHash.toString().length != 40) {
        throw new Error("Invalid wallet public key hash");
    }
    if (receipt.refundPublicKeyHash.toString().length != 40) {
        throw new Error("Invalid refund public key hash");
    }
    if (receipt.refundLocktime.toString().length != 8) {
        throw new Error("Refund locktime must be a 4-byte number");
    }
    const extraData = receipt.extraData;
    if (extraData && extraData.toString().length != 64) {
        throw new Error("Extra data must be a 32-byte number");
    }
}
exports.validateDepositReceipt = validateDepositReceipt;
/* eslint-disable no-unused-vars */
var WalletState;
(function (WalletState) {
    /**
     * The wallet is unknown to the Bridge.
     */
    WalletState[WalletState["Unknown"] = 0] = "Unknown";
    /**
     * The wallet can sweep deposits and accept redemption requests.
     */
    WalletState[WalletState["Live"] = 1] = "Live";
    /**
     * The wallet was deemed unhealthy and is expected to move their outstanding
     * funds to another wallet. The wallet can still fulfill their pending redemption
     * requests although new redemption requests and new deposit reveals are not
     * accepted.
     */
    WalletState[WalletState["MovingFunds"] = 2] = "MovingFunds";
    /**
     *  The wallet moved or redeemed all their funds and is in the
     * losing period where it is still a subject of fraud challenges
     * and must defend against them.
     *  */
    WalletState[WalletState["Closing"] = 3] = "Closing";
    /**
     * The wallet finalized the closing period successfully and can no longer perform
     * any action in the Bridge.
     * */
    WalletState[WalletState["Closed"] = 4] = "Closed";
    /**
     * The wallet committed a fraud that was reported, did not move funds to
     * another wallet before a timeout, or did not sweep funds moved to if from
     * another wallet before a timeout. The wallet is blocked and can not perform
     * any actions in the Bridge.
     */
    WalletState[WalletState["Terminated"] = 5] = "Terminated";
})(WalletState = exports.WalletState || (exports.WalletState = {}));
/* eslint-enable no-unused-vars */
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (WalletState) {
    function parse(val) {
        var _a;
        return ((_a = WalletState[Object.keys(WalletState)[Object.values(WalletState).indexOf(val)]]) !== null && _a !== void 0 ? _a : WalletState.Unknown);
    }
    WalletState.parse = parse;
})(WalletState = exports.WalletState || (exports.WalletState = {}));
//# sourceMappingURL=bridge.js.map